import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { LANG_KEY } from 'src/utils/constants';
import { LanguageCode } from 'src/utils/enums';

@Injectable({
  providedIn: 'root',
})
export class CoreService {
  private addLocaleSource = new BehaviorSubject<any>(
    window.localStorage.getItem(LANG_KEY)
  );
  public addLocale$ = this.addLocaleSource.asObservable();

  constructor() {
    this.addLocale$.subscribe((locale) =>
      window.localStorage.setItem(
        LANG_KEY,
        locale || LanguageCode.UK
      )
    );
  }

  getAddLocale(): Observable<string> {
    let userStatus = window.localStorage.getItem(LANG_KEY);
    this.addLocaleSource.next(userStatus);
    return this.addLocale$;
  }

  getLocale = (): LanguageCode => window.localStorage?.[LANG_KEY];

  setLocale = (locale: LanguageCode) =>
    (window.localStorage[LANG_KEY] = locale);
}
